import { isBefore, isSameDay } from 'date-fns';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { priorities } from '../../../domain';
import { NormalizedAgents } from '../../../resources/agent/types';
import { AlertInTripReviewsInformation } from '../../../resources/in-trip-review/types';
import { AlertPreTripReviewsInformation } from '../../../resources/pre-trip-review/types';
import { DisplayDossiersTodo } from '../../../resources/todo/types';

import s from '../Todo.css';

import { DossierTodo } from './DossierTodo';

import { ReviewsAlert } from './ReviewsAlert';

type Props = {
    dossiers: DisplayDossiersTodo;
    agents: NormalizedAgents;
    currentDate: number;
    hasTripReviews: boolean | null;
    preTripReviews: AlertPreTripReviewsInformation[];
    inTripReviews: AlertInTripReviewsInformation[];
};

export const TodayTodo = ({
    hasTripReviews,
    preTripReviews,
    inTripReviews,
    dossiers,
    agents,
    currentDate,
}: Props): JSX.Element => {
    const location = useLocation();

    const isNotFilteredByConnectedAgent = !location.search || location.search === '?agentId';

    return (
        <React.Fragment>
            {hasTripReviews && (
                <ReviewsAlert
                    preTripReviews={preTripReviews}
                    inTripReviews={inTripReviews}
                    isNotFilteredByConnectedAgent={isNotFilteredByConnectedAgent}
                />
            )}
            <h1 className={s.dateTitle}>
                <FormattedDate value={currentDate} month="long" weekday="long" day="numeric" />
            </h1>
            {priorities
                .filter((priority) => dossiers[priority].length)
                .map((priority) => (
                    <React.Fragment key={priority}>
                        {/* eslint-disable-next-line no-restricted-syntax -- CSS class name, not a color */}
                        <h2 className="white">
                            <FormattedMessage id={`todo.priority.${priority}`} />
                        </h2>
                        <div
                            className={s[`${priority}Priority`]}
                            data-testid={`${priority}-priority`}
                        >
                            <div data-testid="late-dossier-todo">
                                {dossiers[priority]
                                    .filter(
                                        (dossier) =>
                                            isBefore(dossier.task.dueDate, currentDate) &&
                                            !isSameDay(dossier.task.dueDate, currentDate),
                                    )
                                    .map((dossier) => (
                                        <DossierTodo
                                            isLate
                                            agent={agents[dossier.agentId]}
                                            key={dossier.id}
                                            value={dossier}
                                        />
                                    ))}
                            </div>
                            <div data-testid="todo-dossiers-currentPeriod">
                                {dossiers[priority]
                                    .filter((dossier) =>
                                        isSameDay(dossier.task.dueDate, currentDate),
                                    )
                                    .map((dossier) => (
                                        <DossierTodo
                                            agent={agents[dossier.agentId]}
                                            key={dossier.id}
                                            value={dossier}
                                        />
                                    ))}
                            </div>
                        </div>
                    </React.Fragment>
                ))}
        </React.Fragment>
    );
};
